import { memo } from 'react';

import { FlatpickrWrapper } from 'components/field/DateInput';

import * as S from './FilterInput.styled';

/**
 * @author Burak Unsal
 */
const DynamicListDateInput = (props) => {
	const { value, setValue, rangeMode } = props;

	return (
		<S.InputContainer>
			<FlatpickrWrapper value={value} setValue={setValue} rangeMode={rangeMode} filterMode inline />
		</S.InputContainer>
	);
};

export default memo(DynamicListDateInput);
